// Phones and iPhones do not support HTML5 drag and drop on list items, so channels, categories and
// voice members could not be moved. Hold an item briefly (~0.25 s) and then drag it: we replay the same
// dragstart/dragover/drop events the desktop handlers already use. Holding still for 0.5 s still opens the menu.
const touch = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
if (touch) {
  const ARM = 250, MENU = 500;
  let src: HTMLElement | null = null, t0 = 0, sx = 0, sy = 0, dragging = false, over: Element | null = null, ghost: HTMLElement | null = null, dt: DataTransfer | null = null, lastX = 0, lastY = 0;
  const fire = (el: Element | null, type: string, x: number, y: number) => {
    if (!el) return false;
    let ev: Event;
    try { ev = new DragEvent(type, { bubbles: true, cancelable: true, clientX: x, clientY: y, dataTransfer: dt! }); }
    catch { ev = new MouseEvent(type, { bubbles: true, cancelable: true, clientX: x, clientY: y }); Object.defineProperty(ev, 'dataTransfer', { value: dt }); }
    el.dispatchEvent(ev); return ev.defaultPrevented;
  };
  const reset = () => { src?.classList.remove('touch-drag-source'); ghost?.remove(); document.body.classList.remove('touch-dragging'); src = null; dragging = false; over = null; ghost = null; dt = null; };
  window.addEventListener('touchstart', e => {
    if (e.touches.length !== 1) { if (dragging) { fire(src, 'dragend', lastX, lastY); } reset(); return; }
    const el = (e.target as HTMLElement)?.closest?.('[draggable="true"]') as HTMLElement | null;
    if (!el || (e.target as HTMLElement).closest('input,textarea,button:not([draggable])>*')) { src = null; return; }
    src = el; t0 = performance.now(); sx = lastX = e.touches[0].clientX; sy = lastY = e.touches[0].clientY;
  }, { passive: true });
  window.addEventListener('touchmove', e => {
    if (!src) return;
    const t = e.touches[0]; if (!t) return; lastX = t.clientX; lastY = t.clientY;
    if (!dragging) {
      const moved = Math.hypot(t.clientX - sx, t.clientY - sy), held = performance.now() - t0;
      if (moved < 6) return;
      if (held < ARM || held >= MENU) { src = null; return; } // quick swipe = scroll; long hold = context menu
      try { dt = new DataTransfer(); } catch { dt = null; }
      if (!dt) { src = null; return; }
      dragging = true; document.body.classList.add('touch-dragging'); src.classList.add('touch-drag-source');
      try { (navigator as any).vibrate?.(8); } catch {}
      fire(src, 'dragstart', sx, sy);
      const r = src.getBoundingClientRect(); ghost = src.cloneNode(true) as HTMLElement; ghost.className += ' touch-drag-ghost';
      ghost.style.cssText = `position:fixed;left:${r.left}px;top:${r.top}px;width:${r.width}px;height:${r.height}px;pointer-events:none;z-index:10001;margin:0`;
      document.body.appendChild(ghost);
    }
    if (e.cancelable) e.preventDefault();
    const r = src.getBoundingClientRect();
    if (ghost) ghost.style.transform = `translate(${t.clientX - sx}px,${t.clientY - sy}px)`;
    const target = document.elementFromPoint(t.clientX, t.clientY);
    if (target !== over) { if (over) fire(over, 'dragleave', t.clientX, t.clientY); over = target; if (over) fire(over, 'dragenter', t.clientX, t.clientY); }
    if (over) fire(over, 'dragover', t.clientX, t.clientY);
    // Auto-scroll the list near its edges.
    const list = src.closest('.channel-list,.side-scroll,.channel-sidebar-scroll') || src.parentElement?.closest('[class*="scroll"]');
    if (list) { const lr = list.getBoundingClientRect(); if (t.clientY < lr.top + 40) list.scrollTop -= 8; else if (t.clientY > lr.bottom - 40) list.scrollTop += 8; }
    void r;
  }, { passive: false });
  const end = (cancel: boolean) => {
    if (!src) return;
    if (dragging) {
      const ok = !cancel && over ? fire(over, 'dragover', lastX, lastY) : false;
      if (ok) fire(over, 'drop', lastX, lastY);
      fire(src, 'dragend', lastX, lastY);
      // Swallow the click iOS sends after the touch.
      const swallow = (ev: Event) => { ev.preventDefault(); ev.stopPropagation(); };
      window.addEventListener('click', swallow, { capture: true, once: true }); setTimeout(() => window.removeEventListener('click', swallow, { capture: true }), 400);
    }
    reset();
  };
  window.addEventListener('touchend', () => end(false), { passive: true });
  window.addEventListener('touchcancel', () => end(true), { passive: true });
}
export {};
